import style from './style.css';
import { faqRoute, contactUsRoute } from '../../../alias/homeRoutes';
import {
  aboutUsRoute,
  termsAndCondition,
  privacyPolicy,
  dataManagementPolicy,
  blogRoute,
} from '../../../alias/commonRoutes';
import SeoFooterContent from '../seoFooterContent';
import { generateUrlWithParams } from '../../../utils/routeHandler';
import { isNavMenuRoute } from '../../../utils/navBar';
import { tracker, UserActionType } from '../../../tracking';
import { useSelector } from 'react-redux';
import { isMobile } from '../../../utils/helper';
import Utils from '../../../utils';

const GenericFooter = (props) => {
  const addExtraMargin = () => {
    if (isNavMenuRoute() && isMobile && Utils.isOrganicSite()) {
      return true;
    }
    return false;
  };
  const pageKey = props.pageKey
    ? props.pageKey
    : useSelector((state) => state.config.pageKey);
  return (
    <div
      className={`${style.footerContainer} ${addExtraMargin() &&
        style.footerContainerWithBottomNav}`}>
      <div
        className={`${style.footerInnerContainer} ${props.onNeutralTemplate &&
          style.footerInnerContainerOnNeutralTemplate}`}>
        <SeoFooterContent />
        <div
          className={`${style.footerLinks} ${props.onNeutralTemplate &&
            style.footerLinksOnNeutralTemplate}`}>
          <div className={style.footerLink}>
            <a
              href={generateUrlWithParams(aboutUsRoute.path)}
              onClick={() => {
                tracker.trackUserInteraction(
                  UserActionType.CLICK,
                  'ic_footer_about_us',
                  pageKey,
                );
              }}
              target='_blank'
              rel='noopener'
              native>
              About Instacred
            </a>
          </div>
          <div className={style.footerLink}>
            <a
              href={generateUrlWithParams(privacyPolicy.path)}
              onClick={() => {
                tracker.trackUserInteraction(
                  UserActionType.CLICK,
                  'ic_footer_privacy_policy',
                  pageKey,
                );
              }}
              target='_blank'
              rel='noopener'
              native>
              Privacy Policy
            </a>
          </div>
          <div className={style.footerLink}>
            <a
              href={generateUrlWithParams('/blog')}
              onClick={() => {
                tracker.trackUserInteraction(
                  UserActionType.CLICK,
                  'ic_footer_blog',
                  pageKey,
                );
              }}
              target='_blank'
              rel='noopener'
              native>
              Blog
            </a>
          </div>
          <div className={style.footerLink}>
            <a
              href={generateUrlWithParams(termsAndCondition.path)}
              onClick={() => {
                tracker.trackUserInteraction(
                  UserActionType.CLICK,
                  'ic_footer_terms_and_conditions',
                  pageKey,
                );
              }}
              target='_blank'
              rel='noopener'
              native>
              Terms & Conditions
            </a>
          </div>
          <div className={style.footerLink}>
            <a
              href={generateUrlWithParams(faqRoute.path)}
              onClick={() => {
                tracker.trackUserInteraction(
                  UserActionType.CLICK,
                  'ic_footer_faq',
                  pageKey,
                );
              }}
              target='_blank'
              rel='noopener'
              native>
              FAQ
            </a>
          </div>
          <div className={style.footerLink}>
            <a
              href={dataManagementPolicy.path}
              onClick={() => {
                tracker.trackUserInteraction(
                  UserActionType.CLICK,
                  'ic_footer_data_management_policy',
                  pageKey,
                );
              }}
              target='_blank'
              rel='noopener'
              native>
              Data Management Policy
            </a>
          </div>

          <div className={style.footerLink}>
            <a
              href={contactUsRoute.path}
              onClick={() => {
                tracker.trackUserInteraction(
                  UserActionType.CLICK,
                  'ic_footer_contact_us',
                  pageKey,
                );
              }}
              target='_blank'
              rel='noopener'
              native>
              Contact Us
            </a>
          </div>
        </div>
        <div className={style.tradeMark}>©Flexmoney Technologies Pvt. Ltd.</div>
      </div>
    </div>
  );
};

export default GenericFooter;



// WEBPACK FOOTER //
// ./componentsBICRevamp/common/genericFooter/index.js